import {IEntity, IEntityAttribute, IEntityAttributeProperties, IEntityHeader} from "../PA.MD.Core/PA.MD.IF.Entity";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {WB_AttributeTypeRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash"
import {IDateRange} from "../PA.Core/PA.Core.IF.Basic";
import {DateUtils} from "../PA.Core/Basic/Dates";

export interface ICustomAttributeFields {
    WB_ATTRIBUTEM_ID?: number;
    WB_SALESAREA_ID?: number;
    ENTITY_ID_UI?: string;
    ENTITY_KEYSET?: string;
    VALUE_WB_ID?: number;
    VALUE_STRING?: string;
    VALUE_NUMBER?: number;
    SOURCE_ID?: string;
    EFFECTIVE_START_DT?: string;
    EFFECTIVE_END_DT?: string;
    CREATED_DTTS?: number;
    MODIFIED_DTTS?: number;
    DELETED_IND?: string;
    DELETED_DT?: string;
    [k: string]: any;
}

export class CustomAttribute
    implements IEntityAttribute
{
    constructor(attrParent: IEntity,
                attrType: WB_AttributeTypeRow,
                dataRow: ESRecord & ICustomAttributeFields)
    {
        this.attrParent = attrParent
        this.attrType = attrType
        this.dataRow = dataRow
        this.keyFieldName = dataRow._mapper().idAttribute
    }

    private attrParent: IEntity;
    private attrType: WB_AttributeTypeRow;
    private dataRow: ESRecord & ICustomAttributeFields
    private keyFieldName: string

    get row_id(): string {
        return (<any> this.dataRow || {})[this.keyFieldName]
    }

    get type(): WB_AttributeTypeRow {
        return this.attrType
    }

    get bReadOnly(): boolean { return false }

    get parent(): IEntity {
        return this.attrParent
    }

    get wbSalesAreaId(): number {
        return  this.dataRow.WB_SALESAREA_ID || 0
    }


    get attribute_value(): string | number {
        switch (this.attrType.cif.DATATYPE){
            case "number":
                return this.dataRow.VALUE_NUMBER
            case "string":
                return this.dataRow.VALUE_STRING
            case "entity":
            default:
                return 0

        }
    }



    get entity_wb_id(): number {
        return this.dataRow.VALUE_WB_ID
    }

    get entity_wbEntityTypeId(): number {
        return  this.type.cif.WB_ENTITY_ID_TARGET
    }

    get effectiveRange(): IDateRange {
        return {
            StartDt:  DateUtils.convertFromSAPBW(this.dataRow.EFFECTIVE_START_DT),
            EndDt:  DateUtils.convertFromSAPBW(this.dataRow.EFFECTIVE_END_DT),
        }
    }


    //-- Updates
    setBasicValue(value: string | number): void {
        switch (this.attrType.cif.DATATYPE){
            case "number":
                this.dataRow.VALUE_NUMBER = +value
            case "string":
                this.dataRow.VALUE_STRING = value + ''
            case "entity":
            default:

        }

        this.attrParent.EntityAttributesChanged.next({
            Entity: this.attrParent,
            Attribute: this
        })

    }

    setEntity(entity: IEntityHeader): void {
        if(_.isEmpty(entity)) {
            this.dataRow.VALUE_WB_ID = 0
            this.dataRow.ENTITY_KEYSET = ""
            this.dataRow.ENTITY_ID_UI = ""
        } else {
            this.dataRow.VALUE_WB_ID = entity.wb_id
            this.dataRow.ENTITY_KEYSET = entity.key_set
            this.dataRow.ENTITY_ID_UI = entity.id_ui
        }
        this.attrParent.EntityAttributesChanged.next({
            Entity: this.attrParent,
            Attribute: this
        })

    }

    setProperties(props: IEntityAttributeProperties): void {
        let p = props || {}

        if(this.attrType.bSalesAreaInd && ('wbSalesAreaId' in p)){
            let wbSalesAreaId = +props.wbSalesAreaId
            if(_.isNumber(wbSalesAreaId))
                this.dataRow.WB_SALESAREA_ID = wbSalesAreaId
        }

        if(this.attrType.bEffectiveDateInd && ('dateFrom' in p)){
            let dt = p.dateFrom
            this.dataRow.EFFECTIVE_START_DT = DateUtils.convertToSAPBW(p.dateFrom)
        }

        if(this.attrType.bEffectiveDateInd && ('dateThru' in p)){
            let dt = p.dateThru
            this.dataRow.EFFECTIVE_END_DT = DateUtils.convertToSAPBW(p.dateThru)
        }

        this.attrParent.EntityAttributesChanged.next({
            Entity: this.attrParent,
            Attribute: this
        })

    }

    //-- Remove
    async Delete(): Promise<void> {
        this.dataRow.markDeleted()

        this.attrParent.EntityAttributesChanged.next({
            Entity: this.attrParent,
            Attribute: this
        })
    }

    get bDeleted(): boolean {
        return ! this.dataRow.isActive
    }


}